import { useState } from "react";
import SettingsButton from "../../../components/Buttons/SettingsButton/SettingsButton";
import RingLoader from "../../../components/Loaders/RingLoader";
import deviceService from "../../../services/device/deviceService";
import { BellSvgSmall } from "../../../components/Icons/svgIcons";
import scpService from "../../../services/scp/scpService";

const FindMyDevice = ({ id }) => {
    const [vibrationEnabled, setVibrationEnabled] = useState(false);
    const [modeLoading, setModeLoading] = useState(false);

    const setVibrationMode = async (state) => {
        setModeLoading(true);
        try { 
            await scpService.runWithBackOff(id, () => deviceService.setVibration(id, state));
        } catch (e) {
            console.error(e);
        }
        setModeLoading(false);
    };

    const onClickHandler = () => {
        if (!vibrationEnabled) {
            setVibrationMode(true);
            setVibrationEnabled(true)
        } else {
            setVibrationMode(false);
            setVibrationEnabled(false)
        }
    }

    const ButtonContent = () => {
        return (
            <>
                {modeLoading ?
                    <RingLoader size={20} color="black"></RingLoader> :
                    <div className="flex w-full">
                        <BellSvgSmall isSelected={vibrationEnabled} />
                        <div className="grow-1 w-full">
                            {vibrationEnabled ? "Turn off vibration" : "Find device"}
                        </div>
                    </div>
                }
            </>
        );
    }

    return (
        <>  
            <div className="text-m text-start">Find my device:</div>
            <SettingsButton className="border border-gray-200 rounded-md h-14 mb-2" onClick={() => onClickHandler()} disabled={modeLoading}>
                <ButtonContent/>
            </SettingsButton>
        </>
    );
};

export default FindMyDevice;